"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformValidationErrorsToArrayString = transformValidationErrorsToArrayString;
const getValidationMessages = (validationErrors) => {
    const validationMessages = [];
    validationErrors.forEach((error) => {
        if (error.constraints) {
            Object.keys(error.constraints).forEach((childKey) => {
                if (error.constraints) {
                    validationMessages.push(error.constraints[childKey]);
                }
            });
        }
        if (error.children && error.children.length > 0) {
            validationMessages.push(...getValidationMessages(error.children));
        }
    });
    return validationMessages;
};
function transformValidationErrorsToArrayString(validationErrors) {
    return getValidationMessages(validationErrors);
}
//# sourceMappingURL=transformValidationErrorsToArrayString.js.map